import React from "react";
import HeroBanner from "../Sections/HeroBanner";
import TransfersSearch from "../Component/TransfersSearch";
import Tag from "../Component/Tag";
import TransferFilter from "../Component/TransferFilter";
import TransferPagination from "../Component/TransferPagination";
import transferResultData from "../mocks/TransferResult.json";
import TransferSingleResult from "../Component/TransferSingleResult";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";
import { IoLockClosedOutline } from "react-icons/io5";
import { CiFaceSmile, CiShoppingCart } from "react-icons/ci";
import { IoTicketOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";

const whySydneyTransfer = [
  {
    icon: <CiFaceSmile />,
    title: "100% Refund Guarantee",
    text: "Cancel up to 48 hours before you travel.",
  },
  {
    icon: <IoTicketOutline />,
    title: "Fixed Pricing",
    text: "No Surge, No Meter, No Surprises",
  },
  {
    icon: <CiShoppingCart />,
    title: "Extra Luggage Options",
    text: "For When one bag is not enough",
  },
  {
    icon: <IoLockClosedOutline />,
    title: "Safe & Secure Payment",
    text: "Master Card, Paypal, American Express, Visa",
  },
];

const TransferSearchResult = () => {
  const location = useLocation();
  //console.log(location.state?.result);
  const get_quote = Array.isArray(location.state?.result.Get_Quote) ? location.state?.result.Get_Quote : null;
  const book_now = Array.isArray(location.state?.result.Book_now) ? location.state?.result.Book_now : null;
  
  const realData = get_quote || book_now || [];
  //console.log(realData);
  const itemsPerPage = 50000; // Number of items per page
  const transferNavigate = useNavigate();


  const handlePayLater = (e, transferData, responcetype) => {
     //console.log(responcetype);
    transferNavigate(`/transfer-search/${transferData.vehicle_id}`, {
      state: { transferData, responcetype },
    });
  };

  const handlePayNow = (e, transferData, responcetype) => {
    transferNavigate(`/transfer-search/${transferData.vehicle_id}`, {
      state: { transferData, responcetype },
    });
  };

  let formattedData = [];

  if (book_now) {
    formattedData = realData.map((transferData, index) => (
      <div key={index}>
        <TransferSingleResult
          id={transferData.vehicle_id}
          imgUrl={transferData.vehicle_img}
          title={transferData.vehicle_type_name}
          vehicleType={transferData.vehicle_type_des}
          model={transferData.model}
          lugg={transferData.max_lugg}
          make={transferData.make}
          pax={transferData.max_pax}
          responcetype='book_now'
          price={transferData.price}
          meet_greet={transferData.meet_greet}
          trasnfer_type={transferData.trasnfer_type}
          water_bottle={transferData.water_bottle}
          handlePayLater={(e) => handlePayLater(e, transferData ,"pay_later")}
          handlePayNow={(e) => handlePayNow(e, transferData, "book_now")}
        />
      </div>
    ));
  } else if (get_quote) {
    formattedData = realData.map((transferData, index) => (
      <div key={index}>
        <TransferSingleResult
          id={transferData.vehicle_id}
          imgUrl={transferData.vehicle_img}
          title={transferData.vehicle_type_name}
          vehicleType={transferData.vehicle_type_des}
          model={transferData.model}
          lugg={transferData.max_lugg}
          make={transferData.make}
          pax={transferData.max_pax}
          responcetype='get_qoute'
          handlePayLater={(e) => handlePayLater(e, transferData)}
          handlePayNow={(e) => handlePayNow(e, transferData, "get_qoute")}
        />
      </div>
    ));
  }
  


  return (
    <>
      <div className="hidden lg:block">
        <HeroBanner
          text={"Search"}
          imgUrl={"/assets/contact/hero-banner.png"}
        />
      </div>
      <div className="flex justify-center w-full lg:absolute pt-[100px] pb-12 lg:py-0 lg:-mt-12">
        <TransfersSearch resultPage />
      </div>
      <div className="container mx-auto lg:pt-20 lg:pb-8">
        <div className="mx-3">
          <Tag text={"Your Search Result"} center />
          <div className="mt-12 lg:flex gap-6 relative">
            {/* <div className="lg:w-1/3 ">
              <div className="absolute lg:relative right-0">
                <TransferFilter />
              </div>
              <div className="hidden lg:block border rounded w-80 p-4 mt-6">
                <h3 className="font-bold mb-3">
                  Why book on Sydney Transfers?
                </h3>
                {whySydneyTransfer.map((x, index) => (
                  <div key={index} className="flex gap-3 mt-4">
                    <div className="h-10 w-10 flex flex-none bg-primary text-white justify-center items-center rounded-full text-2xl">
                      {x.icon}
                    </div>
                    <div>
                      <p className="font-semibold">{x.title}</p>
                      <p className="">{x.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}
            <div className="w-full pb-12">
              <TransferPagination
                data={formattedData}
                itemsPerPage={itemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransferSearchResult;
